import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { getList, getImageById } from './logUsuarioActions';
import { getList as getUsuariosList } from '../usuario/usuarioActions';
import SPButton from '../common/form/spButton';
import Button from '../common/form/button';
import ReactTable from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import If from '../common/operator/if';
import { PAGE_SIZE } from '../common/utils/pageSize';

moment.locale('pt-br');

class LogUsuarioList extends Component {
  constructor(props) {
    super(props);

    this.getImage = this.getImage.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.handleChangeTime = this.handleChangeTime.bind(this);

    this.state = {
      show: false,
      html: '',
      dataAlteracao: '',
      data: [],
      pages: null,
      loading: false,
      selectedDays: 7,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleDaysChange = this.handleDaysChange.bind(this);
  }

  formatPlanoForcadoAneis(anelValue) {
    const anel = parseInt(anelValue, 10);

    if (!anel) return 'Todos';
    if (anel === 15) return 'Todos';
    if (anel >= 1 && anel <= 4) return `${anel}`;

    const aneis = [];
    for (let index = 1; index <= 4; index++) {
      if ((anel & Math.pow(2, index - 1)) > 0) {
        aneis.push(index);
      }
    }

    if (aneis.length === 0) return `${anelValue || ''}`;
    if (aneis.length === 1) return `${aneis[0]}`;

    const ultimoAnel = aneis.pop();
    return `${aneis.join(', ')} e ${ultimoAnel}`;
  }

  componentDidMount() {
    this.props.getUsuariosList();

    // Quando o componente monta, define loading como false se já tem dados
    if (this.props.data && this.props.data.length > 0) {
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    // Quando os dados mudam de vazio para com dados, define loading como false
    if (
      this.state.loading &&
      this.props.data &&
      this.props.data.length > 0 &&
      (!prevProps.data || prevProps.data.length === 0)
    ) {
      this.setState({ loading: false });
    }

    if (this.props.onDataLoaded && prevProps.data !== this.props.data) {
      this.props.onDataLoaded();
    }
  }

  fetchData(state) {
    this.setState({ loading: true });

    this.lastTableState = state;

    const hasDateFilter = state.filtered && state.filtered.some(item => item.id === 'data_registro' && item.value);
    const daysFilter = hasDateFilter ? null : this.state.selectedDays;

    console.time('[LogUsuarioList] fetchData');
    console.log('[LogUsuarioList] fetchData params', {
      page: state.page,
      sorted: state.sorted,
      filtered: state.filtered,
      selectedDays: this.state.selectedDays,
      daysFilter,
    });

    this.props.getList(state.page, state.sorted, state.filtered, daysFilter).then(() => {
      console.timeEnd('[LogUsuarioList] fetchData');
      this.setState({
        loading: false,
      });
    });
  }

  handleDaysChange(days) {
    this.setState({ loading: true, selectedDays: days }, () => {
      const state = this.lastTableState || {
        page: 0,
        sorted: [],
        filtered: [],
      };

      const hasDateFilter = state.filtered && state.filtered.some(item => item.id === 'data_registro' && item.value);
      const daysFilter = hasDateFilter ? null : days;

      this.props.getList(0, state.sorted, state.filtered, daysFilter).then(() => {
        this.setState({ loading: false });
      });
    });
  }

  handleClose() {
    this.setState({ show: false });
  }

  async getImage(id, data, rowData) {
    this.setState({ loading: true });
    const image = await this.props.getImageById(id).then(() => {
      return this.props.image;
    });
    this.setState({ loading: false });

    if (image !== null) {
      // Tentar diferentes formatos de data para evitar "Invalid date"
      let dataFormatada;
      try {
        dataFormatada = moment(data).format('DD/MM/YYYY HH:mm:ss');
      } catch (error) {
        // Fallback se moment falhar
        dataFormatada = data || 'Data não disponível';
      }

      // Verificar se existem múltiplas imagens (novo formato)
      let imageContent;
      try {
        const parsedImage = JSON.parse(image);
        if (parsedImage.allImages && Array.isArray(parsedImage.allImages)) {
          // Múltiplas páginas - mostrar todas
          imageContent = (
            <div>
              <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
                {parsedImage.allImages.length} página(s) capturada(s):
              </p>
              {parsedImage.allImages.map((img, index) => (
                <div key={index} style={{ marginBottom: '20px' }}>
                  <h5 style={{ marginBottom: '10px' }}>Página {index + 1}:</h5>
                  <img
                    src={img}
                    alt={`Página ${index + 1}`}
                    style={{
                      maxWidth: '100%',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      marginBottom: '10px',
                    }}
                  />
                </div>
              ))}
            </div>
          );
        } else {
          // Formato antigo - uma imagem
          imageContent = <img src={`${image}`} alt="" style={{ maxWidth: '100%' }} />;
        }
      } catch (error) {
        // Se não conseguir fazer parse, tratar como imagem simples
        imageContent = <img src={`${image}`} alt="" style={{ maxWidth: '100%' }} />;
      }

      this.setState({
        html: imageContent,
        dataAlteracao: dataFormatada,
      });
      this.setState({ show: true });
    }
  }

  timeFormat(time) {
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);
    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;
    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  }

  handleChangeTime(value, onChange) {
    const time = this.timeFormat(value);
    onChange(time);
  }

  getTelaLabel(value) {
    switch (value) {
      case 'controlador':
        return 'Controlador';
      case 'data_especial':
        return 'Data Especial';
      case 'intervalo':
        return 'Intervalo Plano';
      case 'plano':
        return 'Plano';
      case 'tabela_troca':
        return 'Tabela de Troca';
      case 'plano_forcado':
        return 'Plano Forçado';
      default:
        return value || '-';
    }
  }

  getAcaoLabel(value, original) {
    if (original && original.tabela_nome === 'controlador' && parseInt(value) === 2) {
      try {
        const dados = typeof original.dados === 'string' ? JSON.parse(original.dados) : original.dados;
        if (dados && dados.controlador_id && (dados.ativo === 1 || dados.ativo === -1)) {
          return dados.ativo === 1 ? 'Online' : 'Offline';
        }
      } catch (e) {}
    }

    switch (value) {
      case 1:
        return 'Cadastro';
      case 2:
        return 'Alteração';
      case 3:
        return 'Exclusão';
      case 4:
        return 'Reset (Central)';
      case 5:
        return 'Envia';
      default:
        return value || '-';
    }
  }

  getAcaoClass(value, original) {
    const label = this.getAcaoLabel(value, original);

    switch (label) {
      case 'Cadastro':
      case 'Online':
        return 'success';
      case 'Alteração':
      case 'Envia':
        return 'info';
      case 'Exclusão':
      case 'Offline':
        return 'danger';
      case 'Reset (Central)':
        return 'warning';
      default:
        return 'neutral';
    }
  }

  render() {
    const { data, total, usuarios } = this.props;

    const pages = Math.ceil(total / PAGE_SIZE);
    const totalPagina = data ? data.length : 0;
    const periodOptions = [0, 7, 15, 30, 90];

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <If condicao={!!row.original.has_image}>
            <SPButton
              type="button"
              className="success btn btn-sm log-action-button"
              icon="search"
              data-title=""
              onClick={() => this.getImage(row.original.id, row.original.data_hora_completa, row.original)}
            />
          </If>
        ),
        className: 'column_icon',
        width: 72,
        sortable: false,
        filterable: true,
        resizable: true,
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Tela',
        accessor: 'tabela_nome',
        width: 210,
        className: 'column_grid',
        filterable: true,
        resizable: true,
        Cell: ({ value }) => (
          <span className="log-chip log-chip-light log-chip-strong">{this.getTelaLabel(value)}</span>
        ),
        Filter: ({ filter, onChange }) => (
          <select
            onChange={e => onChange(e.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'Todos'}
            name="tabela_nome"
          >
            <option value="">Todos</option>
            <option value="controlador">Controlador</option>
            <option value="data_especial">Data Especial</option>
            <option value="intervalo">Intervalo Plano</option>
            <option value="plano">Plano</option>
            <option value="tabela_troca">Tabela de Troca</option>
            <option value="plano_forcado">Plano Forçado</option>
          </select>
        ),
      },
      {
        Header: 'Usuário',
        accessor: 'usuario_desc',
        width: 180,
        className: 'column_grid',
        filterable: true,
        resizable: true,
        Cell: ({ value }) => <span className="log-user-text">{value || '-'}</span>,
        Filter: ({ filter, onChange }) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : ''}
            name="usuario_desc"
          >
            <option value="">Todos</option>
            {usuarios &&
              usuarios.map(usuario => (
                <option key={usuario.id} value={usuario.id}>
                  {usuario.nome}
                </option>
              ))}
          </select>
        ),
      },
      {
        Header: 'Data',
        accessor: 'data_registro',
        width: 140,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => <span className="log-date-text">{moment(value).format('DD/MM/YYYY')}</span>,
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            style={{ width: '100%' }}
            type="date"
            name="data_registro"
            className="form-control"
          />
        ),
      },

      {
        Header: 'Hora',
        accessor: 'hora_registro',
        width: 120,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Cell: ({ value }) => <span className="log-time-text">{value || '-'}</span>,
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => this.handleChangeTime(event.target.value, onChange)}
            value={filter ? filter.value : ''}
            type="text"
            name="hora_registro"
            maxLength={8}
            placeholder="hh:mm:ss"
            className="form-control"
          />
        ),
      },
      {
        Header: 'Ação',
        accessor: 'tipo',
        width: 130,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Cell: ({ value, original }) => (
          <span className={`log-chip log-chip-${this.getAcaoClass(value, original)}`}>
            {this.getAcaoLabel(value, original)}
          </span>
        ),
        filterMethod: (filter, row) => {
          switch (filter.value) {
            case '1':
              return parseInt(row[filter.id]) === 1;
            case '2':
              return parseInt(row[filter.id]) === 2;
            case '3':
              return parseInt(row[filter.id]) === 3;
            case '4':
              return parseInt(row[filter.id]) === 4;
            case '5':
              return parseInt(row[filter.id]) === 5;
            default:
              return true;
          }
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'Todos'}
            name="tipo"
          >
            <option value="">Todos</option>
            <option value="1">Cadastro</option>
            <option value="2">Alteração</option>
            <option value="3">Exclusão</option>
            <option value="4">Reset (Central)</option>
            <option value="5">Envia</option>
          </select>
        ),
      },
      {
        Header: 'Grupo',
        accessor: 'grupo_fisico',
        width: 90,
        className: 'column_grid column_center',
        filterable: false,
        resizable: true,
        Cell: ({ value }) => <span className="log-plain-text">{value || 'Todos'}</span>,
      },
      {
        Header: 'Controlador',
        accessor: 'numero_controlador',
        width: 130,
        filterable: false,
        className: 'column_grid column_center',
        resizable: true,
        Cell: ({ value }) => <span className="log-controller-text">{value || '-'}</span>,
      },
      {
        Header: 'Anel',
        accessor: 'anel',
        width: 110,
        filterable: false,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value, original }) => {
          if (original && original.tabela_nome === 'plano_forcado') {
            return <span className="log-plain-text">{this.formatPlanoForcadoAneis(value)}</span>;
          }

          return <span className="log-plain-text">{value || '-'}</span>;
        },
      },
    ];

    return (
      <>
        <style>{`
          .log-toolbar-actions {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
            justify-content: flex-end;
          }

          .log-toolbar-meta {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            border-radius: 999px;
            background: rgba(241, 245, 249, 0.7);
            color: #475569;
            padding: 7px 11px;
            font-size: 12px;
            font-weight: 500;
          }

          .log-days-group {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px;
            border-radius: 999px;
            background: rgba(248, 250, 252, 0.96);
            border: 1px solid rgba(226, 232, 240, 0.95);
          }

          .log-days-button {
            border: 0;
            border-radius: 999px;
            background: transparent;
            color: #64748b;
            font-size: 12px;
            font-weight: 500;
            padding: 7px 12px;
            transition: all 0.2s ease;
          }

          .log-days-button:hover {
            background: rgba(59, 130, 246, 0.08);
            color: #334155;
          }

          .log-days-button.active {
            background: rgba(59, 130, 246, 0.1);
            color: #1d4ed8;
            font-weight: 600;
          }

          .log-chip {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 999px;
            padding: 6px 10px;
            font-size: 12px;
            font-weight: 500;
            line-height: 1.2;
            white-space: nowrap;
          }

          .log-chip-strong {
            font-weight: 600;
          }

          .log-chip-light { background: rgba(239, 246, 255, 0.6); color: #31558f; }
          .log-chip-muted { background: rgba(241, 245, 249, 0.75); color: #526173; }
          .log-chip-outline { background: rgba(255, 255, 255, 0.7); color: #526173; border: 1px solid rgba(219, 228, 238, 0.9); }
          .log-chip-success { background: rgba(236, 253, 245, 0.6); color: #2f7d67; }
          .log-chip-info { background: rgba(239, 246, 255, 0.6); color: #4368a8; }
          .log-chip-danger { background: rgba(254, 242, 242, 0.6); color: #c05b5b; }
          .log-chip-warning { background: rgba(255, 247, 237, 0.65); color: #a56b3f; }
          .log-chip-neutral { background: rgba(248, 250, 252, 0.75); color: #526173; }

          .log-user-text,
          .log-controller-text,
          .log-date-text,
          .log-time-text {
            font-weight: 500;
            color: #334155;
          }

          .log-plain-text {
            font-weight: 500;
            color: #526173;
          }

          .log-action-button {
            border-radius: 10px !important;
            min-width: 30px;
            min-height: 30px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 6px 14px rgba(22, 163, 74, 0.18);
          }

          @media (max-width: 767px) {
            .log-toolbar-actions {
              justify-content: flex-start;
            }
          }
        `}</style>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-mapa">
          <Modal.Header className="modal-header" closeButton>
            <Modal.Title>Log de Alteração {this.state.dataAlteracao}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body" align="center">
            {this.state.loading ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#3c8dbc' }} />
                <br />
                <p style={{ marginTop: '10px', color: '#666' }}>Carregando imagem...</p>
              </div>
            ) : (
              this.state.html
            )}
          </Modal.Body>
          <Modal.Footer className="modal-header">
            <Button type="button" className="primary" icon="close" label="Fechar" onClick={this.handleClose} />
          </Modal.Footer>
        </Modal>

        <PremiumTableShell
          summary={`${totalPagina} registro(s) na página atual, ${total || 0} logs no período selecionado`}
          loading={this.state.loading || this.props.forceLoading}
          loadingText="Carregando logs..."
          tableMinWidth={980}
          toolbarRight={
            <div className="log-toolbar-actions">
              <span className="log-toolbar-meta">Período recente</span>
              <div className="log-days-group">
                {periodOptions.map(days => (
                  <button
                    key={days}
                    type="button"
                    className={`log-days-button ${this.state.selectedDays === days ? 'active' : ''}`}
                    onClick={() => this.handleDaysChange(days)}
                  >
                    {days === 0 ? 'Todo período' : `${days} dias`}
                  </button>
                ))}
              </div>
            </div>
          }
        >
          <ReactTable
            manual
            data={data}
            columns={columns}
            pages={pages}
            loading={this.state.loading}
            onFetchData={this.fetchData}
            filterable
            className="-striped -highlight"
            defaultPageSize={PAGE_SIZE}
            showPaginationBottom={true}
          />
        </PremiumTableShell>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getList, getImageById, getUsuariosList }, dispatch);
export default connect(
  state => ({
    data: state.logusuarioCad.list,
    total: state.logusuarioCad.total,
    ips: state.logusuarioCad.ips,
    image: state.logusuarioCad.image,
    usuarios: state.usuarioCad.list,
  }),
  mapDispatchToProps,
)(LogUsuarioList);
